import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/movies';
import SectionHeading from '@/components/feature/SectionHeading';

export default function NewsSection() {
  return (
    <section>
      <SectionHeading
        icon="ri-newspaper-line"
        title="影视资讯专题"
        subtitle="行业要闻、新剧推荐与市场观察"
        action={
          <span className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-400 sm:flex">
            持续更新中 <i className="ri-refresh-line"></i>
          </span>
        }
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {newsList.map((news) => (
          <article key={news.id} className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
            <div className="relative h-44 w-full overflow-hidden bg-background-200">
              <img
                src={news.cover}
                alt={news.title}
                title={`${news.title} - 神马影院资讯`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
                {news.category}
              </span>
            </div>
            <div className="space-y-2 p-4">
              <h3 className="line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {news.title}
              </h3>
              <p className="line-clamp-2 text-sm leading-relaxed text-foreground-500">{news.summary}</p>
              <p className="flex items-center gap-1 pt-1 text-xs text-foreground-400">
                <i className="ri-calendar-line"></i> {news.date}
              </p>
            </div>
          </article>
        ))}
      </div>
      <div className="mt-5 text-center">
        <Link
          to="/category/tv"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-500"
        >
          发现更多热门剧集 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
    </section>
  );
}